import { render } from "./CorrectionSessionPage.vue?vue&type=template&id=30ba2bb7&ts=true"
import script from "./CorrectionSessionPage.vue?vue&type=script&lang=ts"
export * from "./CorrectionSessionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__